import React, { useEffect, useState } from "react";
import CustomTable from "../../components/table/customTable";
import { useNavigate } from "react-router-dom";
import ENDPOINTS from "../../services/endPoints";
import useGet from "../../hooks/useGet";
import QUERY_KEYS from "../../services/queryKeys";
import { paymentTableHeaderList } from "../../utils/seeds/tableHeaders";
import PaymentListRow from "../../components/table/tableRows/paymentHistoryRow";

const PaymentHistoryManagement = () => {
  const [countData, setCountData] = useState(15);
  const [pageNumber, setPageNumber] = useState(1);
  const [searchInput, setSearchInput] = useState("");
  const nav = useNavigate();

  const {
    data: paymentListData,
    isLoading: isLoadingPayments,
    refetch: refetchPaymentList,
  } = useGet(
    ENDPOINTS.GET_PAYMENT_HISTORY,
    QUERY_KEYS.GET_PAYMENT_HISTORY_QUERY_KEY,
    {
      page: pageNumber,
      limit: countData,
      search: searchInput,
    }
  );

  // const handelView = (item) => {
  //   nav(RoutePath.USER_DETAIL.path, {
  //     state: { headerName: RoutePath.USER_DETAIL.title },
  //   });
  //   localStorage.setItem(userGlobalConfig.USER_ID, JSON.stringify(item?._id));
  // };
  const handlePrevPage = () => {
    setPageNumber((prevPage) => prevPage - 1);
  };

  const handleNextPage = () => {
    setPageNumber((nextPage) => nextPage + 1);
  };
  const handleRowLimitChange = (newValue) => {
    if (
      pageNumber === Math.ceil(paymentListData?.pagination?.total / countData)
    ) {
      setPageNumber(1);
    }
    setCountData(newValue);
  };
  useEffect(() => {
    refetchPaymentList();
  }, [pageNumber, countData]);

  //onSearch Change
  const onSearchChange = (e) => {
    setSearchInput(e.target.value);
  };

  //onSearch button
  const onSearchButtonClick = (e) => {
    e.preventDefault();
    setPageNumber(1);
    refetchPaymentList();
  };

  return (
    <>
      <CustomTable
        isLoading={isLoadingPayments}
        heading="Recent Payments"
        tableHeaderList={paymentTableHeaderList}
        handlePrevPage={handlePrevPage}
        handleNextPage={handleNextPage}
        handleRowLimitChange={handleRowLimitChange}
        currentPage={pageNumber}
        totalPages={paymentListData?.pagination?.total}
        countData={countData}
        searchBarRequired={false}
        onSearchChange={onSearchChange}
        searchInput={searchInput}
        onSearchButtonClick={onSearchButtonClick}
      >
        <PaymentListRow
          onView={() => {}}
          data={paymentListData?.data}
          isLoading={isLoadingPayments}
        />
      </CustomTable>
    </>
  );
};

export default PaymentHistoryManagement;
